/** Suffix to be placed at the end of the form field. */
import { Directive } from '@angular/core';

@Directive({
    selector: '[appSuffix]',
})
export class AppSuffixDirective {}
